import React, { FC, PropsWithChildren, useEffect, useRef } from 'react';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  onClickOutside: () => void;
}

export const WithClickOutside: FC<PropsWithChildren<Props>> = (props: Props) => {
  const { children, onClickOutside, ...restProps } = props;
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    document.addEventListener('click', handleClickInOrOutside);
    return () => document.removeEventListener('click', handleClickInOrOutside);
  }, []);

  const handleClickInOrOutside = (event: MouseEvent) => {
    const withinBoundaries = event.composedPath().includes(ref.current);

    if (!withinBoundaries) {
      onClickOutside();
    }
  };

  return (
    <div ref={ref} {...restProps}>
      {children}
    </div>
  );
};
